<div class="sb-dialog-container-outlet">
  <ng-template cdkPortalOutlet></ng-template>
</div>
